export default __webpack_public_path__ + "static/media/cut.3a217569.svg";